// PdfTemplate Form Component

/* eslint react/jsx-indent: 0,
  react/jsx-curly-newline: 0,
  react/jsx-closing-bracket-location: 0,
  react/jsx-handler-names: 0 */

import { ThemeProvider, lightTheme, NumberInput } from '@rodeo-dev/legos'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import app from '../../../app.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import Select from '../../../common/form/select/select.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'
import PdfTemplateItem from '../pdftemplate_item/pdftemplate_item.jsx'
import PdfTemplateUpload from '../pdftemplate_upload/pdftemplate_upload.jsx'
import { PDF_HEADER_HEIGHT, PDF_FOOTER_HEIGHT } from '../../../../shared/constants'

const VALID_EXTENSIONS = {
  PDF: ['pdf'],
  JPG: ['jpg', 'jpeg']
}

const isValidHeightPercentage = (value, constEntry) =>
  value >= constEntry.MIN && value <= constEntry.MAX
const getInvalidHeightPercentageText = (min, max) =>
  IntlUtil.convertMessage('setting.pdfTemplate.invalidHeightPercentage', {
    min: Math.round(min * 100),
    max: Math.round(max * 100)
  })

class PdfTemplateForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedIdent: 'estimate',
      dataDate: null
    }

    this.data = {
      pdfTemplates: [
        { ident: 'estimate', title: 'setting.pdfTemplate.titleEstimatePdf' },
        { ident: 'invoice', title: 'setting.pdfTemplate.titleInvoicePdf' },
        { ident: 'purchaseorder', title: 'setting.pdfTemplate.titlePoPdf' },
        {
          ident: 'terms_condition',
          title: 'setting.pdfTemplate.titleTermsandConditon'
        }
      ],
      bTemplateFileUploaded: false,
      bTemplateFileSecondaryUploaded: false,
      teamPdfTemplates: props.teamPdfTemplates || []
    }

    this._currTemplate = this._getTemplateObject(this.state.selectedIdent)
  }

  static get propTypes () {
    return {
      fontFamilies: PropTypes.array,
      onSubmit: PropTypes.func,
      onError: PropTypes.func,
      teamPdfTemplates: PropTypes.array,
      onPdfPreview: PropTypes.func,
      uploadError: PropTypes.func,
      isQuickbookConnected: PropTypes.bool,
      termsAndCondition: PropTypes.string,
      onSubmitTermsAndCondition: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onError: null,
      teamPdfTemplates: [],
      onPdfPreview: null,
      uploadError: null,
      isQuickbookConnected: false,
      onSubmitTermsAndCondition: null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.teamPdfTemplates !== this.data.teamPdfTemplates) {
      this.data.teamPdfTemplates = nextProps.teamPdfTemplates
      this._currTemplate = this._getTemplateObject(this.state.selectedIdent)
    }
  }

  render () {
    const bTermsAndCondition = this.state.selectedIdent === 'terms_condition'
    return (
      <div className='pdftemplate-form'>
        <div className='colleft'>
          <h3 className='title'>
            <IntlMessage ident='setting.pdfTemplate.titlePdfTemplate' />
          </h3>
          {this._renderPdfItems()}
        </div>
        <div className='colright'>
          <form
            className='pdfform'
            method='post'
            noValidate
            action='#'
            onSubmit={this._onFormSubmit}
          >
            <div className='formheader'>
              <h2 className='title'>
                <IntlMessage
                  ident={this._getTitleByIdent(this.state.selectedIdent)}
                />
              </h2>
            </div>
            <div className='formcontent'>
              {bTermsAndCondition
                ? this._renderTermsConditionField()
                : this._renderDefaultTemplateField()}
            </div>
          </form>
        </div>
      </div>
    )
  }

  _renderDefaultTemplateField () {
    const currTemplate = this._currTemplate

    return (
      <>
        <div className='formrow'>
          <div className='formfield'>
            <Checkbox
              label='setting.pdfTemplate.companyLogo'
              checked={currTemplate.showLogo}
              icon='common'
              onChange={this._onChangeInput.bind(this, 'showLogo')}
            />
          </div>
        </div>
        <div className='formrow'>
          <div className='formfield'>
            <Checkbox
              label='setting.pdfTemplate.companyaddress'
              checked={currTemplate.showAddress}
              icon='common'
              onChange={this._onChangeInput.bind(this, 'showAddress')}
            />
          </div>
        </div>
        <div className='formrow'>
          <div className='formfield'>
            <Checkbox
              label='setting.pdfTemplate.footer'
              checked={currTemplate.showFooter}
              icon='common'
              onChange={this._onChangeInput.bind(this, 'showFooter')}
            />
          </div>
        </div>
        {(this.state.selectedIdent === 'invoice' ||
          this.state.selectedIdent === 'estimate') && (
          <div className='formrow'>
            <div className='formfield'>
              <Checkbox
                label='setting.pdfTemplate.pageNumbers'
                checked={currTemplate.showPageNumbers}
                icon='common'
                onChange={this._onChangeInput.bind(this, 'showPageNumbers')}
              />
            </div>
          </div>
        )}
        {this.state.selectedIdent === 'estimate' && (
          <div className='formrow'>
            <div className='formfield'>
              <Checkbox
                label='setting.pdfTemplate.labelSign'
                checked={currTemplate.showSign}
                icon='common'
                onChange={this._onChangeInput.bind(this, 'showSign')}
              />
            </div>
          </div>
        )}
        <div className='formrow'>
          <div className='formfield'>
            <Select
              label='setting.pdfTemplate.placeholderStyle'
              className='form-dropdown'
              options={this.getFontList()}
              onChange={this._onChangeInput.bind(this, 'fontFamily')}
              multilingualOptions={!this.useNewPdfService()}
              value={this.getSelectedFontKey(currTemplate.fontFamily)}
              name='style'
            />
          </div>
        </div>
        {this._renderTermsAndCondition()}
        {this.useNewPdfService() && (
          <>
            <div className='formrow height-title'>
              <h2>
                <IntlMessage ident='setting.pdfTemplate.backgroundContentHeightTitle' />
              </h2>
              <p>
                <IntlMessage ident='setting.pdfTemplate.backgroundContentHeightDescription' />
              </p>
            </div>
            <div className='formrow'>
              <ThemeProvider theme={lightTheme}>
                <div className='height-inputs'>
                  <NumberInput
                    label={IntlUtil.convertMessage(
                      'setting.pdfTemplate.headerHeightPercentage'
                    )}
                    allowNegative={false}
                    decimalScale={0}
                    onValueChange={val =>
                      this._onChangeInput(
                        'headerHeightPercentage',
                        val.floatValue / 100
                      )
                    }
                    type='text'
                    value={Math.round(
                      currTemplate.headerHeightPercentage * 100
                    )}
                    error={
                      !isValidHeightPercentage(
                        currTemplate.headerHeightPercentage,
                        PDF_HEADER_HEIGHT
                      )
                    }
                    helperText={
                      !isValidHeightPercentage(
                        currTemplate.headerHeightPercentage,
                        PDF_HEADER_HEIGHT
                      ) &&
                      getInvalidHeightPercentageText(
                        PDF_HEADER_HEIGHT.MIN,
                        PDF_HEADER_HEIGHT.MAX
                      )
                    }
                    InputProps={{
                      endAdornment: <div className='percentage-symbol'>%</div>
                    }}
                  />
                  <NumberInput
                    label={IntlUtil.convertMessage(
                      'setting.pdfTemplate.footerHeightPercentage'
                    )}
                    allowNegative={false}
                    decimalScale={0}
                    onValueChange={val =>
                      this._onChangeInput(
                        'footerHeightPercentage',
                        val.floatValue / 100
                      )
                    }
                    type='text'
                    value={Math.round(
                      currTemplate.footerHeightPercentage * 100
                    )}
                    error={
                      !isValidHeightPercentage(
                        currTemplate.footerHeightPercentage,
                        PDF_FOOTER_HEIGHT
                      )
                    }
                    helperText={
                      !isValidHeightPercentage(
                        currTemplate.footerHeightPercentage,
                        PDF_FOOTER_HEIGHT
                      ) &&
                      getInvalidHeightPercentageText(
                        PDF_FOOTER_HEIGHT.MIN,
                        PDF_FOOTER_HEIGHT.MAX
                      )
                    }
                    InputProps={{
                      endAdornment: <div className='percentage-symbol'>%</div>
                    }}
                  />
                </div>
              </ThemeProvider>
            </div>
          </>
        )}

        <div className='formrow'>
          <div className='formfield'>
            <PdfTemplateUpload
              fileObj={currTemplate.templateFile}
              uploadSuccess={this._onUploadFile.bind(this, 'templateFile')}
              uploadError={this._uploadError.bind(this, 'uploadFirstErr')}
              error={this.state.uploadFirstErr}
              uploadClassName='firstupload'
              onDeleteClick={this._onDeleteFile.bind(this, 'templateFile')}
              attachmentInfo={
                this.useNewPdfService()
                  ? 'setting.pdfTemplate.firstPageBackgroundUpload'
                  : 'setting.pdfTemplate.firstPageAttachmentInfo'
              }
              uploadWithStoneAirballoon={this.useNewPdfService()}
            />
          </div>
        </div>
        <div className='formrow'>
          <div className='formfield'>
            <PdfTemplateUpload
              fileObj={currTemplate.templateFileSecondary}
              uploadSuccess={this._onUploadFile.bind(
                this,
                'templateFileSecondary'
              )}
              uploadError={this._uploadError.bind(this, 'uploadSecondaryErr')}
              error={this.state.uploadSecondaryErr}
              uploadClassName='secondupload'
              onDeleteClick={this._onDeleteFile.bind(
                this,
                'templateFileSecondary'
              )}
              attachmentInfo={
                this.useNewPdfService()
                  ? 'setting.pdfTemplate.remainingPagesBackgroundUpload'
                  : 'setting.pdfTemplate.secondPageAttachmentInfo'
              }
              uploadWithStoneAirballoon={this.useNewPdfService()}
            />
          </div>
        </div>
        <Button
          className='button_save button_view'
          title='setting.pdfTemplate.titleSave'
          canHover={false}
          type='button'
          icon='common-success-tick'
          onClick={this._onFormSubmit}
        />
        <Button
          className='button_save button_view preview'
          title='setting.pdfTemplate.preview'
          canHover={false}
          type='button'
          onClick={this._onPdfPreview.bind(this)}
        />
      </>
    )
  }

  _renderTermsAndCondition () {
    const currTemplate = this._currTemplate

    return (
      <>
        <div className='formrow height-title'>
          <h2>
            <IntlMessage ident='setting.pdfTemplate.titleTermsandConditon' />
          </h2>
        </div>
        <div className='formrow'>
          <div className='formfield'>
            <div className='content'>
              <WysiwygEditor
                className='termseditor'
                placeholder='setting.pdfTemplate.titleTermsandConditon'
                isUpdatable
                value={currTemplate.termsAndCondition}
                onChange={this._onChangeInputValue.bind(this)}
              />
            </div>
          </div>
        </div>
      </>
    )
  }

  _renderTermsConditionField () {
    const currTemplate = this._currTemplate

    return (
      <>
        <div className='formrow'>
          <div className='formfield'>
            <PdfTemplateUpload
              fileObj={currTemplate.templateFile}
              uploadSuccess={this._onUploadFile.bind(this, 'templateFile')}
              uploadError={this._uploadError.bind(this, 'uploadFirstErr')}
              error={this.state.uploadFirstErr}
              uploadClassName='firstupload'
              onDeleteClick={this._onDeleteFile.bind(this, 'templateFile')}
              attachmentInfo='setting.pdfTemplate.titleUploadDefaultTermsAndCondition'
              // this is a temporary setting, since we have not migrated terms and conditions
              // we still need to upload them on Minio not GCS
              uploadWithStoneAirballoon={this.useNewPdfService()}
            />
          </div>
        </div>
        <Button
          className='button_save button_view'
          title='setting.pdfTemplate.titleSave'
          canHover={false}
          type='button'
          icon='common-success-tick'
          onClick={this._onFormSubmit}
        />
        {currTemplate.templateFile && (
          <Button
            className='button_save button_view preview'
            title='setting.pdfTemplate.preview'
            canHover={false}
            type='button'
            onClick={this._onPdfPreview.bind(this)}
          />
        )}
      </>
    )
  }

  _renderPdfItems () {
    const { isQuickbookConnected } = this.props

    return (
      <div className='cont'>
        {this.data.pdfTemplates.map((tempItem, idx) => {
          if (isQuickbookConnected && tempItem.ident === 'invoice') {
            return null
          }

          return (
            <PdfTemplateItem
              key={idx}
              selected={this.state.selectedIdent === tempItem.ident}
              title={tempItem.title}
              active={this._isItemActive(tempItem.ident)}
              onClick={this._onClickTemplateItem.bind(this, tempItem.ident)}
            />
          )
        })}
      </div>
    )
  }

  _onClickTemplateItem (ident) {
    if (this.state.selectedIdent !== ident) {
      this._currTemplate = this._getTemplateObject(ident)
      this.setState({
        selectedIdent: ident,
        uploadFirstErr: '',
        uploadSecondaryErr: ''
      })
    }
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _getTitleByIdent (ident) {
    const item = _.find(
      this.data.pdfTemplates,
      template => template.ident === ident
    )
    if (item) {
      return item.title
    }

    return ''
  }

  _getTemplateObject (ident) {
    const existObj = _.find(
      this.data.teamPdfTemplates,
      item => item.ident === ident
    )
    let templateObj = null
    if (existObj) {
      templateObj = _.cloneDeep(existObj)
      if (typeof existObj.headerHeightPercentage !== 'number') {
        templateObj.headerHeightPercentage = PDF_HEADER_HEIGHT.DEFAULT
      }
      if (typeof existObj.footerHeightPercentage !== 'number') {
        templateObj.footerHeightPercentage = PDF_FOOTER_HEIGHT.DEFAULT
      }
    } else {
      templateObj = {
        id: null,
        active: false,
        ident: ident,
        file: null,
        showLogo: true,
        showAddress: true,
        showFooter: true,
        showPageNumbers: true,
        showSign: false,
        fontFamily: 'standard-rodeo-font',
        headerHeightPercentage: PDF_HEADER_HEIGHT.DEFAULT,
        footerHeightPercentage: PDF_FOOTER_HEIGHT.DEFAULT,
        termsAndCondition: ''
      }
    }

    return templateObj
  }

  /* Event handlers */
  _onChangeInput (name, value) {
    this._currTemplate[name] = value
    this._refresh()
  }

  _onChangeInputValue (value) {
    this._currTemplate.termsAndCondition = value
    this._refresh()
  }

  _onUploadFile (name, file, message, e) {
    const ext = Util.getExtension(message.id)

    const validExtensions = this.useNewPdfService()
      ? VALID_EXTENSIONS.JPG
      : VALID_EXTENSIONS.PDF

    if (validExtensions.includes(ext)) {
      if (name === 'templateFile') {
        this._currTemplate.templateFile = {
          fileName: message.id,
          name: file.name,
          url: `asset/${message.id}`
        }
        this.data.bTemplateFileUploaded = true
      } else if (name === 'templateFileSecondary') {
        this._currTemplate.templateFileSecondary = {
          fileName: message.id,
          name: file.name,
          url: `asset/${message.id}`
        }
        this.data.bTemplateFileSecondaryUploaded = true
      }

      this.setState({ uploadFirstErr: '', uploadSecondaryErr: '' })
    } else {
      e.preventDefault()
      e.stopPropagation()
      this.setState({
        uploadFirstErr: 'hasErr',
        uploadSecondaryErr: 'hasErr',
        dataDate: new Date()
      })
    }
  }

  _uploadError (name, file, message) {
    if (message) {
      const stateObj = { dataDate: new Date() }
      if (name === 'uploadFirstErr') {
        stateObj.uploadFirstErr = 'hasErr'
      } else {
        stateObj.uploadSecondaryErr = 'hasErr'
      }
      this.setState(stateObj)

      if (this.props.uploadError) {
        this.props.uploadError(message)
      }
    }
  }

  _onDeleteFile (name) {
    if (name === 'templateFile') {
      this._currTemplate.templateFile = null
      this.data.bTemplateFileDeleted = true
      this.data.bTemplateFileUploaded = false
    } else if (name === 'templateFileSecondary') {
      this._currTemplate.templateFileSecondary = null
      this.data.bTemplateFileSecondaryDeleted = true
      this.data.bTemplateFileSecondaryUploaded = false
    }

    this.setState({ dataDate: new Date() })
  }

  _onFormSubmit = ev => {
    ev.preventDefault()

    if (this.props.onSubmit) {
      const currTemplate = this._currTemplate
      const templateData = {
        ident: currTemplate.ident,
        showLogo: currTemplate.showLogo,
        showAddress: currTemplate.showAddress,
        showFooter: currTemplate.showFooter,
        showPageNumbers:
          currTemplate.ident === 'invoice' || currTemplate.ident === 'estimate'
            ? currTemplate.showPageNumbers
            : currTemplate.showFooter,
        showSign: currTemplate.showSign,
        fontFamily: currTemplate.fontFamily
          ? currTemplate.fontFamily
          : 'standard-rodeo-font',
        active: true,
        headerHeightPercentage: currTemplate.headerHeightPercentage,
        footerHeightPercentage: currTemplate.footerHeightPercentage,
        termsAndCondition: currTemplate.termsAndCondition
      }

      const fileInfo = {
        templateFile: null,
        templateFileSecondary: null
      }

      if (this.data.bTemplateFileUploaded && currTemplate.templateFile) {
        fileInfo.templateFile = {
          fileName: currTemplate.templateFile.fileName,
          name: currTemplate.templateFile.name
        }
      }

      if (
        this.data.bTemplateFileSecondaryUploaded &&
        currTemplate.templateFileSecondary
      ) {
        fileInfo.templateFileSecondary = {
          fileName: currTemplate.templateFileSecondary.fileName,
          name: currTemplate.templateFileSecondary.name
        }
      }

      let fileDeleted = null
      if (
        this.data.bTemplateFileDeleted ||
        this.data.bTemplateFileSecondaryDeleted
      ) {
        fileDeleted = {
          templateFile: !!this.data.bTemplateFileDeleted,
          templateFileSecondary: !!this.data.bTemplateFileSecondaryDeleted
        }
      }

      this.props.onSubmit(templateData, currTemplate.id, fileInfo, fileDeleted)
      this.data.bTemplateFileDeleted = false
      this.data.bTemplateFileSecondaryDeleted = false
      this.data.bTemplateFileUploaded = false
      this.data.bTemplateFileSecondaryUploaded = false
    }
  }

  _onPdfPreview (ev) {
    ev.preventDefault()

    if (this.props.onPdfPreview) {
      const currTemplate = this._currTemplate
      const templateData = {
        ident: currTemplate.ident,
        showLogo: currTemplate.showLogo,
        showAddress: currTemplate.showAddress,
        showFooter: currTemplate.showFooter,
        showSign: currTemplate.showSign,
        showPageNumbers:
          currTemplate.ident === 'invoice' || currTemplate.ident === 'estimate'
            ? currTemplate.showPageNumbers
            : currTemplate.showFooter,
        fontFamily: currTemplate.fontFamily
          ? currTemplate.fontFamily
          : 'standard-rodeo-font',
        active: true,
        headerHeightPercentage: currTemplate.headerHeightPercentage,
        footerHeightPercentage: currTemplate.footerHeightPercentage
      }

      const fileInfo = {
        templateFile: null,
        templateFileSecondary: null
      }

      if (currTemplate.templateFile) {
        fileInfo.templateFile = {
          fileName: currTemplate.templateFile.fileName,
          name: currTemplate.templateFile.name
        }
      }

      if (currTemplate.templateFileSecondary) {
        fileInfo.templateFileSecondary = {
          fileName: currTemplate.templateFileSecondary.fileName,
          name: currTemplate.templateFileSecondary.name
        }
      }

      const existObj = {
        bTemplateFileUploaded: !!(
          currTemplate.templateFile && !this.data.bTemplateFileUploaded
        ),
        bTemplateFileSecondaryUploaded: !!(
          currTemplate.templateFileSecondary &&
          !this.data.bTemplateFileSecondaryUploaded
        )
      }

      this.props.onPdfPreview(templateData, currTemplate.id, fileInfo, existObj)
    }
  }

  _isItemActive (ident) {
    const existObj = _.find(
      this.data.teamPdfTemplates,
      item => item.ident === ident
    )
    if (existObj) {
      return existObj.active
    }

    return false
  }

  getSelectedFontKey (selectedFontKey) {
    const fontOption = this.getFontList().find(v => v.value === selectedFontKey)
    return (fontOption && fontOption.value) || 'standard-rodeo-font'
  }

  getFontList () {
    const fontFamilies = this.props.fontFamilies

    if (this.state.selectedIdent !== 'terms_condition' && fontFamilies) {
      return fontFamilies.map(({ label, key }) => {
        if (key === 'standard-rodeo-font') {
          return {
            label: `${IntlUtil.convertMessage(
              'setting.pdfTemplate.standardRodeoFont'
            )} (${label})`,
            value: key
          }
        }
        return { label, value: key }
      })
    }

    return [
      {
        label: 'setting.pdfTemplate.standardRodeoFont',
        value: 'standard-rodeo-font'
      },
      { label: 'setting.pdfTemplate.openSans', value: 'open-sans' },
      { label: 'setting.pdfTemplate.merriweather', value: 'merriweather' },
      { label: 'setting.pdfTemplate.vollkorn', value: 'vollkorn' },
      { label: 'setting.pdfTemplate.ubuntu', value: 'ubuntu' },
      { label: 'setting.pdfTemplate.lato', value: 'lato' },
      { label: 'setting.pdfTemplate.calibre', value: 'calibre' },
      { label: 'setting.pdfTemplate.timesNewRoman', value: 'times-new-roman' }
    ]
  }

  useNewPdfService () {
    if (this.state.selectedIdent === 'terms_condition') return false
    return app.getFeatureToggles().FEATURE_USE_NEW_PDF_SERVICE === 'true'
  }
}

export default PdfTemplateForm
